import React from 'react';

/**
 * SchoolCard
 * actions: array of { label, className, onClick }
 */
export default function SchoolCard({ school, actions = [], onBook, onViewDetails }) {
  const { name, address, phone, email, description, capacity,
          operatingHours, ageRange, facilities = [], status } = school;

  return (
    <div className="school-card">
      <div className="school-card-header">
        <div className="school-card-header-left">
          <h3>{name}</h3>
          <p>{description || 'Daycare & early education centre'}</p>
        </div>
      </div>

      <div className="school-card-body">
        <div className="school-card-stamp" aria-hidden="true" />
        <div className="school-info-row"><span className="icon">📍</span>{address}</div>
        <div className="school-info-row"><span className="icon">📞</span>{phone}</div>
        <div className="school-info-row school-info-hide-mobile"><span className="icon">✉️</span>{email}</div>
        <div className="school-info-row"><span className="icon">🕐</span>{operatingHours}</div>
        <div className="school-info-row"><span className="icon">👶</span>Age: {ageRange}</div>
        <div className="school-info-row school-info-hide-mobile" style={{ flexWrap: 'wrap', gap: 6 }}>
          <span className="icon">🏫</span>
          <span>Capacity: {capacity}</span>
        </div>

        {facilities.length > 0 && (
          <div className="school-info-hide-mobile" style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {facilities.map((f, i) => (
              <span key={i} className="meta-tag" style={{ fontSize: 11 }}>✅ {f}</span>
            ))}
          </div>
        )}

        <div className="school-info-hide-mobile" style={{ marginTop: 8 }}>
          <span className={`badge badge-${status === 'active' ? 'active' : 'inactive'}`}>
            {status === 'active' ? '🟢 Active' : '⚫ Inactive'}
          </span>
        </div>
      </div>

      <div className="school-card-footer">
        {onBook && status === 'active' && (
          <button className="btn btn-primary btn-sm" onClick={() => onBook(school)}>Book Slot</button>
        )}
        {onViewDetails && (
          <button className="btn btn-outline btn-sm sd-view-btn" onClick={() => onViewDetails(school)}
            style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            View Details
          </button>
        )}
        {actions.map((a, i) => (
          <button key={i} className={`btn btn-sm ${a.className || 'btn-outline'}`} onClick={() => a.onClick(school)}>
            {a.label}
          </button>
        ))}
      </div>
    </div>
  );
}
